import { Alert } from 'antd';

type ErrorAlertProps = {
    message: string;
    onDismiss: () => void;
};

export const ErrorAlert = ({ message, onDismiss }: ErrorAlertProps) => {
    if (!message) return null;
    return (
        <Alert
            message="Ha ocurrido un error"
            description={message}
            type="error"
            showIcon
            closable
            onClose={onDismiss}
            style={{ marginBottom: 16 }}
        />
    );
};
